import 'whatwg-fetch';
import { UAParser } from 'ua-parser-js';
import { EventSourceComet, PollComet, WebSocketComet } from 'shared/api/comet/comets';
export function createComet(api) {
    if (window.WebSocket &&
        window.location.search.indexOf('no-ws') === -1 &&
        api.userInfo?.id !== 1271 &&
        // these two identifiers are of OnePlus 7 Pro phone on which
        // WebSocket connection gots banned somewhy
        navigator.userAgent.indexOf('QKQ1.190716.003') == -1 &&
        navigator.userAgent.indexOf('QQ3A.200905.001') == -1) {
        return new WebSocketComet(api);
    }
    let es_blacklisted = false;
    const parser = new UAParser().getResult();
    if (parser.os.name === 'iOS' &&
        parser.os.version &&
        (~~parser.os.version.split('.')[0] === 6 ||
            ~~parser.os.version.split('.')[0] === 7)) {
        es_blacklisted = true;
    }
    if (location.search.indexOf('no-event-source') !== -1) {
        es_blacklisted = true;
    }
    if (window.EventSource && !es_blacklisted) {
        return new EventSourceComet(api);
    }
    return new PollComet(api);
}
